module.exports = __webpack_public_path__ + "static/media/logo.23d64b2a.svg";